<template>
  <div class="aui-wrapper aui-page__login">
    <div class="aui-content__wrapper">
      <main class="aui-content">
        <div class="login-header">
          <h2 class="login-brand">{{ $t('brand.lg') }}</h2>
        </div>
        <div class="login-body">
          <h3 class="login-title">{{ $t('login.title') }}</h3>
          <el-form
            :model="dataForm"
            :rules="dataRule"
            ref="dataForm"
            @keyup.enter.native="dataFormSubmitHandle()"
            status-icon
          >
            <el-form-item prop="username">
              <el-input v-model="dataForm.username" :placeholder="$t('login.username')">
                <span slot="prefix" class="el-input__icon">
                  <svg class="icon-svg" aria-hidden="true"><use xlink:href="#icon-user"></use></svg>
                </span>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="dataForm.password"
                type="password"
                :placeholder="$t('login.password')"
              >
                <span slot="prefix" class="el-input__icon">
                  <svg class="icon-svg" aria-hidden="true"><use xlink:href="#icon-lock"></use></svg>
                </span>
              </el-input>
            </el-form-item>
            <el-form-item prop="captcha">
              <el-row :gutter="20">
                <el-col :span="14">
                  <el-input v-model="dataForm.captcha" :placeholder="$t('login.captcha')">
                    <span slot="prefix" class="el-input__icon">
                      <svg class="icon-svg" aria-hidden="true"><use xlink:href="#icon-safetycertificate"></use></svg>
                    </span>
                  </el-input>
                </el-col>
                <el-col :span="10" class="login-captcha">
                  <img :src="captchaPath" @click="getCaptcha()" alt="captcha" />
                </el-col>
              </el-row>
            </el-form-item>
            <!-- 短信验证码-->
            <el-form-item v-if="isCode" prop="verificationCode">
              <el-input v-model="dataForm.verificationCode" placeholder="请输入短信验证码">
                <span slot="prefix" class="el-input__icon">
                  <svg class="icon-svg" aria-hidden="true"><use xlink:href="#icon-safetycertificate"></use></svg>
                </span>
              </el-input>
            </el-form-item>
            <el-form-item>
              <!-- 登录按钮-->
              <el-button
                v-if="!isCode"
                type="primary"
                @click="dataFormSubmitHandle()"
                class="w-percent-100"
              >
                {{ $t('login.title') }}
              </el-button>
              <el-button
                v-else
                type="primary"
                @click="codeOk()"
                class="w-percent-100"
              >
               {{ $t('login.title') }}
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-card class="box-card" v-if="showMobileCodeCard">
          <p>中运交投</p>
          <p class="p2">请输入验证码（手机号：{{ mobileNumber }}）</p>
          <div>
            <div class="input-box">
              <div
                class="code-item"
                :class="codeValue.length == 0 && inputFocus ? 'code-item-active' : ''"
              >
                {{ codeValue[0] || '' }}
              </div>
              <div
                class="code-item"
                :class="codeValue.length == 1 && inputFocus ? 'code-item-active' : ''"
              >
                {{ codeValue[1] || '' }}
              </div>
              <div
                class="code-item"
                :class="codeValue.length == 2 && inputFocus ? 'code-item-active' : ''"
              >
                {{ codeValue[2] || '' }}
              </div>
              <div
                class="code-item"
                :class="codeValue.length >= 3 && inputFocus ? 'code-item-active' : ''"
              >
                {{ codeValue[3] || '' }}
              </div>
              <input
                ref="codeInput"
                class="input-code"
                v-model="codeValue"
                :maxlength="4"
                type="tel"
                @blur="codeInputBlur"
                @focus="codeInputFocus"
                @input="codeInputChange"
                autocomplete="one-time-code"
                inputmode="numeric"
                pattern="[0-9]*"
              />
            </div>
          </div>
          <div class="footer-btn">
            <el-button @click="cancelMobileCode()">取消</el-button>
            <el-button @click="verifyMobileCode()">确认</el-button>
          </div>
        </el-card>
        <div class="login-footer">
          <p>
            Copyright @2022 www.zhongyunjiaotou.com All Rights Reserved.中运交投（深圳）投资集团有限公司
            粤ICP备2022114444号-1
          </p>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import debounce from 'lodash/debounce'
import { getUUID } from '@/utils'
export default {
  name: 'Login',
  data () {
    return {
      captchaPath: '',
      isCode: false,
      showMobileCodeCard: false,
      uid: '',
      username: '',
      mobileNumber: '',
      dataForm: {
        username: '',
        password: '',
        uuid: '',
        captcha: '',
        verificationCode: ''
      },
      codeValue: '',
      inputFocus: false,
      smsRequesting: false,
    }
  },
  computed: {
    dataRule () {
      return {
        username: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
      }
    }
  },
  created () {
    this.getCaptcha()
  },
  methods: {
     // my获取验证码
      getVerifyCode() {
      this.time = 120;
      const timer = setInterval(() => {
        this.time --;
        if (this.time <= 0) {
          this.time = 0;
          clearInterval(timer);
        }
      }, 1000);
    },    
    // 验证码输入框input（把四位数同步到 dataForm.verificationCode）
    codeInputChange () {
      if (this.codeValue) {
        this.codeValue = this.codeValue.replace(/\D/g, '')
        .slice(0, 4)
      } else {
        this.codeValue = ''
      }
      if (this.codeValue && this.codeValue.length >= 4) {
        this.dataForm.verificationCode = this.codeValue
      } else {
        this.dataForm.verificationCode = ''
      }
    },
    // 验证码输入框失去焦点
    codeInputBlur () {
      this.inputFocus = false
    },
    // 验证码输入框获取到焦点
    codeInputFocus () {
      this.inputFocus = true
    },
    // 获取图形验证码
    getCaptcha () {
      this.dataForm.uuid = getUUID()
      this.captchaPath = `${window.SITE_CONFIG['apiURL']}/captcha?uuid=${this.dataForm.uuid}`
    },
    // 取消短信验证码输入
    cancelMobileCode () {
      // 清理数据且加载新的图形验证码
      this.showMobileCodeCard = false
      this.mobileNumber = ''
      this.uid = ''
      this.username = ''
      this.dataForm.verificationCode = ''
      this.codeValue = ''
      this.getCaptcha();
    },
    // 正常用户名登录短信验证
    verifyMobileCode () {
      if (!this.dataForm.verificationCode || this.dataForm.verificationCode.length !== 4) {
        this.$message({
          type: 'error',
          message: '请输入正确的验证码。'
        })
        return
      }
      // 调用校验接口
      this.$http.post('/checkMobileCode', {
        uid: this.uid,
        username: this.username,
        mobile: this.mobileNumber,
        code: this.dataForm.verificationCode
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          this.getCaptcha()
          return this.$message.error(res.msg)
        }
        Cookies.set('token', res.data.token)
        this.$router.replace({ name: 'home' })
      }).catch((err) => {
        console.error('verifyMobileCode error', err)
      })
    },
    // 用户名为手机号的登录方法。
    codeOk(){
        console.log(this.dataForm.verificationCode.length,'11')
        if(this.dataForm.verificationCode.length != 4) {
          this.$message({
            type:"error",
            message:'请输入正确的验证码'
          })
        } else {
          this.$http.post('/login', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            this.getCaptcha()
            return this.$message.error(res.msg)
          }
          Cookies.set('token', res.data.token)
          this.$router.replace({ name: 'home' })
         }).catch(() => {})
        }
    },
    // 获取短信验证码
    getMobileVerificationCode (mobile) {
      if (!mobile) return
      if (this.smsRequesting) return
      this.smsRequesting = true
      this.$http.get('/getverificationCode?username='+encodeURIComponent(mobile)).then(r => {
        this.smsRequesting = false
        if (r.data && r.data.code === 0) {
          this.$message({
            type: 'success',
            message: '验证码发送成功'
          })
        } else {
          this.$message({
            type: 'error',
            message: (r.data && r.data.msg) || '验证码发送失败'
          })
        }
      }).catch((err) => {
        this.smsRequesting = false
        console.error('getMobileVerificationCode error', err)
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        if(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.dataForm.username - 0)){
         this.$http.get('/getverificationCode?username='+this.dataForm.username).then(r => {
          if(r.data.code == 0){
            this.$message({
              type:"success",
              message:'验证码发送成功'
            })
            this.isCode = true
          }else{
            this.$message({
              type:"error",
              message:r.data.msg
            })
          }
         })
       } else {
        // 先调用 /login接口校验（用户名/密码/图形验证码），
        // 后端返回securityCheckRequired为true后走短信校验流程。
        // 否则直接登录成功。
          this.$http.post('/login', this.dataForm).then(({ data: res }) => {
            if (res.code !== 0) {
              this.getCaptcha()
              return this.$message.error(res.msg)
            }
            // 需要短信验证码校验
            if (res.data.securityCheckRequired == true) {
              this.uid = res.data.uid
              this.username = res.data.username
              this.mobileNumber = res.data.mobile
              // 展示验证码输入框，并获取短信验证码
              this.showMobileCodeCard = true
              this.getMobileVerificationCode(res.data.mobile)
              this.$nextTick(() => {
                const input = this.$refs.codeInput
                if (input && input.focus) {
                  input.focus()
                }
              })
            } 
            // 登录成功
            else if (res.data.securityCheckRequired == false) {
              Cookies.set('token', res.data.token)
              this.$router.replace({ name: 'home' })
            } 
            // 登录失败
            else {
              this.$message.error('响应参数错误，登录失败。')
            }
          }).catch((err) => {
            console.error('login error', err)
          })
        }
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
<style lang="scss" scoped>
.box-card{
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 500px;
  height: 380px;
  .p2{
    margin: 20px 0;
  }
  .footer-btn{
    height: 50px;
    width: 100%;
    display: flex;
    margin: 60px 0;
    justify-content: space-around;
  }
}

.input-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 80px;
  position: relative;
  padding: 0px 15px;
  box-sizing: border-box;
  .input-code {
    width: 100%;
    height: 50px;
    position: absolute;
    left: 0px;
    top: 0px;
    box-sizing: border-box;
    color: transparent;
    background-color: transparent;
    opacity: 0;
    border: none;
    outline: none;
  }
  .code-item {
    width: 40px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    border-bottom: 1px solid #D8D8D8;
    margin-right: 10px;
    color: #444;
    font-size: 34px;
  }
  .code-item-active {
    border-bottom: 1px solid #F23026;
  }
}
.login-footer{
  width: 100%;
}
</style>
